import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import { VideoPlayer } from '../VideoPlayer';
import ClipLoader from 'react-spinners/BounceLoader';
import screenfull from 'screenfull';
import debounce from 'lodash/debounce';
export function Video({
  url,
  logo_white,
}: {
  url: string;
  logo_white?: string;
}) {
  const [playing, setPlaying] = useState(false);
  const [curTime, setCurTime] = useState(0);
  const [played, setPlayed] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [allTime, setAlltime] = useState(0);
  const [volume, setVolume] = useState(0.7);
  const [muted, setMuted] = useState(false);
  const [isHovered, setIsHovered] = useState(true);

  const [isBuffering, setIsbuffering] = useState(false);
  const player = useRef<ReactPlayer>(null);
  const playerDivRef = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleHoverLeave = React.useCallback(
    debounce(() => setIsHovered(true), 2000),
    []
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleHoverMove = React.useCallback(
    debounce(() => {
      console.log('move');
      setIsHovered(true);
    }, 2000),
    []
  );

  const handleMouseEnter = () => {
    handleHoverLeave.cancel();
    setIsHovered(false);
  };

  const handleSeek = (tosec: number) => {
    player.current?.seekTo(tosec);
  };

  const handleVolume = (volume: number) => {
    setVolume(volume);
  };

  const handleMute = () => {
    setMuted((prev) => !prev);
  };

  const onClickFullscreen = () => {
    if (screenfull.isEnabled) {
      screenfull.toggle(playerDivRef?.current as Element);
    }
  };
  const onChangeBitrate = (event: any) => {
    console.log(event.target.value);
    const internalPlayer = player.current?.getInternalPlayer('hls');
    if (internalPlayer) {
      // currentLevel expect to receive an index of the levels array
      internalPlayer['currentLevel'] = event.target.value;
    }
  };
  return (
    <div className="rounded-md shadow-md relative">
      <div
        className={`relative  ${isBuffering ? 'animate-pulse' : ''} border-b `}
      >
        {isBuffering ? (
          <div className="absolute h-full w-full  bg-gradient-to-t  from-black to-indigo-300  opacity-50 rounded-t flex justify-center items-center  ">
            <ClipLoader size={50} color={'#A5B4FC'} />
          </div>
        ) : null}
        <div className="h-full relative md:h-96 " ref={playerDivRef}>
          <span className={`${isHovered ? 'cursor-none' : ''}`}>
            <ReactPlayer
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleHoverLeave}
              onMouseMove={handleHoverMove}
              onDoubleClick={() => onClickFullscreen()}
              ref={player}
              url={url}
              playing={playing}
              width="100%"
              height="100%"
              volume={volume}
              muted={muted}
              onProgress={({
                played,
                playedSeconds,
                loaded,
                loadedSeconds,
              }) => {
                setCurTime(playedSeconds);
                setPlayed(played);
                setLoaded(loaded);
              }}
              onDuration={(duration) => {
                setAlltime(duration);
                console.log(duration);
              }}
              onBuffer={() => {
                console.log('buff');
                setIsbuffering(true);
              }}
              onBufferEnd={() => {
                console.log('buff end');
                setIsbuffering(false);
              }}
            />
          </span>

          <VideoPlayer
            src=""
            playing={playing}
            onChangeBitrate={onChangeBitrate}
            setPlaying={setPlaying}
            curTime={curTime}
            allTime={allTime}
            volume={volume}
            player={player}
            handleSeek={handleSeek}
            handleVolume={handleVolume}
            onClickFullscreen={onClickFullscreen}
            handleMute={handleMute}
            muted={muted}
            played={played}
            loaded={loaded}
            isHovered={isHovered}
            handleMouseEnter={handleMouseEnter}
            handleHoverLeave={handleHoverLeave}
            logo_white={logo_white}
          />
        </div>
      </div>
    </div>
  );
}
